import axios from "axios"

//0:测试 1:正式
const STATUS = 1;


const HOST = ['https://alpha.api2.tanwuapp.cn/iOS/v2.0','https://api.tanwuapp.com/iOS/v2.0'][STATUS];
const alipayMiniappHost = ["https://testapi.tanwuapp.cn", "https://api.tanwuapp.com"][STATUS]

export const CONFIG = {
	homes:HOST+'/website/homes',
	themeLabels:HOST+"/website/themeLabels",
	themesByLabel:HOST+"/website/themesByLabel",
	themeDetail:HOST+"/website/themeDetail",
	question:HOST+'/help/question',
	joinUs:HOST+'/website/joinUs',
	videoTypes: HOST+'/website/videoTypes', 
    videosByType: HOST+'/website/videosByType', 
	videoDetail:HOST + '/website/videoDetail',
	contactUs:HOST+"/website/contactUs",
	productTypes:HOST+"/website/productTypes",
	// 前端分类
  frontTypeList: alipayMiniappHost + '/anon/app/spu/classification/list',
	products:HOST+"/website/products"
}

export const network = (url,data = {},obj = {}) => {
    return new Promise((resolve, reject) => {
        let askData = {
            url: url,
            method: obj.method || 'GET',
			data: data,
			params:data,
			timeout: 5000
        }
        //get请求特殊处理
        // if(askData.method == 'GET'){
        //     askData.params = data;
		// }else{
		// 	askData.data = data;
		// }
		
        return axios(askData).then(res => {
			let data = res.data;
			if(data.head.code == 0){
				//请求没毛病
				resolve(data);
			}else {
				alert('出了一些问题...')
			}
        }).catch(error => {
			alert('出了一些问题...')
			return new Promise(function(resolve, reject) {
				console.log(error)
			})
        })
    })
}





// WEBPACK FOOTER //
// ./src/assets/js/apis.js